if (!customElements.get('media-gallery')) {
  customElements.define(
    'media-gallery',
    class MediaGallery extends HTMLElement {
      constructor() {
        super();
        this.elements = {
          liveRegion: this.querySelector('[id^="GalleryStatus"]'),
          viewer: this.querySelector('[id^="GalleryViewer"]'),
          thumbnails: this.querySelector('[id^="GalleryThumbnails"]'),
        };
        this.mql = window.matchMedia('(min-width: 750px)');
        if (!this.elements.thumbnails) return;

        this.elements.viewer.addEventListener('slideChanged', debounce(this.onSlideChanged.bind(this), 500));
        this.elements.thumbnails.querySelectorAll('[data-target]').forEach((mediaToSwitch) => {
          mediaToSwitch
            .querySelector('button')
            .addEventListener('click', this.setActiveMedia.bind(this, mediaToSwitch.dataset.target, false));
        });
        if (this.dataset.desktopLayout.includes('thumbnail') && this.mql.matches) this.removeListSemantic();
      }

      onSlideChanged(event) {
        const thumbnail = this.elements.thumbnails.querySelector(
          `[data-target="${event.detail.currentElement.dataset.mediaId}"]`
        );
        this.setActiveThumbnail(thumbnail);
      }

      setActiveMedia(mediaId, prepend) {
        const activeMedia =
          this.elements.viewer.querySelector(`[data-media-id="${mediaId}"]`) ||
          this.elements.viewer.querySelector('[data-media-id]');
        if (!activeMedia) {
          return;
        }
        this.elements.viewer.querySelectorAll('[data-media-id]').forEach((element) => {
          element.classList.remove('is-active');
        });
        activeMedia?.classList?.add('is-active');

        if (prepend) {
          activeMedia.parentElement.firstChild !== activeMedia && activeMedia.parentElement.prepend(activeMedia);

          if (this.elements.thumbnails) {
            const activeThumbnail = this.elements.thumbnails.querySelector(`[data-target="${mediaId}"]`);
            activeThumbnail.parentElement.firstChild !== activeThumbnail && activeThumbnail.parentElement.prepend(activeThumbnail);
          }

          if (this.elements.viewer.slider) this.elements.viewer.resetPages();
        }

        this.preventStickyHeader();
        window.setTimeout(() => {
          if (!this.mql.matches || this.elements.thumbnails) {
            activeMedia.parentElement.scrollTo({ left: activeMedia.offsetLeft });
          }
          const activeMediaRect = activeMedia.getBoundingClientRect();
          if (activeMediaRect.top > -0.5) return;
          const top = activeMediaRect.top + window.scrollY;
          window.scrollTo({ top: top, behavior: 'smooth' });
        });
        this.playActiveMedia(activeMedia);

        if (!this.elements.thumbnails) return;
        const activeThumbnail = this.elements.thumbnails.querySelector(`[data-target="${mediaId}"]`);
        this.setActiveThumbnail(activeThumbnail);
        this.announceLiveRegion(activeMedia, activeThumbnail.dataset.mediaPosition);
      }

      setActiveThumbnail(thumbnail) {
        if (!this.elements.thumbnails || !thumbnail) return;

        this.elements.thumbnails
          .querySelectorAll('button')
          .forEach((element) => element.removeAttribute('aria-current'));
        thumbnail.querySelector('button').setAttribute('aria-current', true);
        if (this.elements.thumbnails.isSlideVisible(thumbnail, 10)) return;

        this.elements.thumbnails.slider.scrollTo({ left: thumbnail.offsetLeft });
      }

      announceLiveRegion(activeItem, position) {
        const image = activeItem.querySelector('.product__modal-opener--image img');
        if (!image) return;
        image.onload = () => {
          this.elements.liveRegion.setAttribute('aria-hidden', false);
          this.elements.liveRegion.innerHTML = window.accessibilityStrings.imageAvailable.replace('[index]', position);
          setTimeout(() => {
            this.elements.liveRegion.setAttribute('aria-hidden', true);
          }, 2000);
        };
        image.src = image.src;
      }

      playActiveMedia(activeItem) {
        window.pauseAllMedia();
        const deferredMedia = activeItem.querySelector('.deferred-media');
        if (deferredMedia) deferredMedia.loadContent(false);
      }

      preventStickyHeader() {
        this.stickyHeader = this.stickyHeader || document.querySelector('sticky-header');
        if (!this.stickyHeader) return;
        this.stickyHeader.dispatchEvent(new Event('preventHeaderReveal'));
      }

      removeListSemantic() {
        if (!this.elements.viewer.slider) return;
        this.elements.viewer.slider.setAttribute('role', 'presentation');
        this.elements.viewer.sliderItems.forEach((slide) => slide.setAttribute('role', 'presentation'));
      }
    }
  );
}

// ============================================================
// 灯箱左右切换 - 暴力修复方案
// 在全局作用域下直接操作 DOM，不依赖事件冒泡
// ============================================================

(function() {
  'use strict';

  var modalImages = [];
  var currentIdx = 0;

  function getModalContent() {
    var modal = document.querySelector('product-modal');
    if (!modal) return null;
    return modal.querySelector('.product-media-modal__content');
  }

  function getAllImages() {
    var content = getModalContent();
    if (!content) return [];
    return Array.from(content.querySelectorAll('[data-media-id]'));
  }

  function showImage(index) {
    var images = getAllImages();
    if (images.length === 0) return;
    // 确保索引在有效范围
    index = ((index % images.length) + images.length) % images.length;
    images.forEach(function(img, i) {
      img.style.display = (i === index) ? '' : 'none';
    });
    currentIdx = index;
  }

  function initGallery() {
    var images = getAllImages();
    if (images.length === 0) {
      // 如果图片还没加载，等一会再试
      setTimeout(initGallery, 200);
      return;
    }
    modalImages = images;
    // 只显示第一张
    showImage(0);
    // 更新箭头显示状态
    var prevBtn = document.querySelector('.modal-slider-button--prev');
    var nextBtn = document.querySelector('.modal-slider-button--next');
    if (images.length < 2) {
      if (prevBtn) prevBtn.style.display = 'none';
      if (nextBtn) nextBtn.style.display = 'none';
    } else {
      if (prevBtn) prevBtn.style.display = 'flex';
      if (nextBtn) nextBtn.style.display = 'flex';
    }
  }

  // ----- 使用 MutationObserver 监听灯箱打开 -----
  function setupModalWatcher() {
    var modal = document.querySelector('product-modal');
    if (!modal) {
      setTimeout(setupModalWatcher, 500);
      return;
    }

    // 监听 modal 的 style 变化
    var observer = new MutationObserver(function() {
      var style = window.getComputedStyle(modal);
      if (style.display !== 'none' && style.visibility !== 'hidden' && style.opacity !== '0') {
        // 灯箱打开了
        setTimeout(function() {
          initGallery();
          // 重新绑定箭头点击（使用全局方式）
          bindArrows();
        }, 150);
      }
    });
    observer.observe(modal, { attributes: true, attributeFilter: ['style', 'class'] });

    // 同时监听 DOM 变化（图片可能是异步加载的）
    var content = getModalContent();
    if (content) {
      var contentObserver = new MutationObserver(function() {
        var images = getAllImages();
        if (images.length > 0 && modalImages.length === 0) {
          initGallery();
        }
      });
      contentObserver.observe(content, { childList: true, subtree: true });
    }
  }

  // ----- 全局绑定箭头点击（使用 window 事件捕获） -----
  function bindArrows() {
    // 先清除所有已有的监听器
    var prevBtn = document.querySelector('.modal-slider-button--prev');
    var nextBtn = document.querySelector('.modal-slider-button--next');

    if (prevBtn) {
      // 克隆替换移除旧监听
      var newPrev = prevBtn.cloneNode(true);
      prevBtn.parentNode.replaceChild(newPrev, prevBtn);
      // 使用最原始的 DOM 0 级事件
      newPrev.onclick = function(e) {
        e = e || window.event;
        e.cancelBubble = true;
        if (e.stopPropagation) e.stopPropagation();
        if (e.stopImmediatePropagation) e.stopImmediatePropagation();
        if (e.preventDefault) e.preventDefault();
        var images = getAllImages();
        if (images.length > 1) {
          var newIndex = (currentIdx - 1 + images.length) % images.length;
          showImage(newIndex);
        }
        return false;
      };
    }

    if (nextBtn) {
      var newNext = nextBtn.cloneNode(true);
      nextBtn.parentNode.replaceChild(newNext, nextBtn);
      newNext.onclick = function(e) {
        e = e || window.event;
        e.cancelBubble = true;
        if (e.stopPropagation) e.stopPropagation();
        if (e.stopImmediatePropagation) e.stopImmediatePropagation();
        if (e.preventDefault) e.preventDefault();
        var images = getAllImages();
        if (images.length > 1) {
          var newIndex = (currentIdx + 1) % images.length;
          showImage(newIndex);
        }
        return false;
      };
    }
  }

  // ----- 键盘支持（使用 keydown 事件） -----
  document.addEventListener('keydown', function(e) {
    var modal = document.querySelector('product-modal');
    if (!modal) return;
    var style = window.getComputedStyle(modal);
    if (style.display === 'none' || style.visibility === 'hidden') return;

    var images = getAllImages();
    if (images.length < 2) return;

    if (e.key === 'ArrowLeft') {
      e.preventDefault();
      e.stopPropagation();
      var newIndex = (currentIdx - 1 + images.length) % images.length;
      showImage(newIndex);
    } else if (e.key === 'ArrowRight') {
      e.preventDefault();
      e.stopPropagation();
      var newIndex = (currentIdx + 1) % images.length;
      showImage(newIndex);
    }
  });

  // ----- 也监听点击打开灯箱的按钮 -----
  document.addEventListener('click', function(e) {
    var target = e.target;
    // 检查是否点击了打开灯箱的元素
    if (target.closest && target.closest('[data-open-modal], .product__media-item a, .product__media-item button')) {
      setTimeout(function() {
        initGallery();
        bindArrows();
      }, 300);
    }
  });

  // ----- 启动 -----
  setupModalWatcher();

  // 页面加载完成后也检查一次
  if (document.readyState === 'complete') {
    setTimeout(function() {
      var modal = document.querySelector('product-modal');
      if (modal) {
        var style = window.getComputedStyle(modal);
        if (style.display !== 'none' && style.visibility !== 'hidden') {
          initGallery();
          bindArrows();
        }
      }
    }, 500);
  }

})();